export const TRIP_TYPES = [
  {
    id: 'one_way',
    label: 'One Way',
    tagline: 'Lowest one-side fares',
    icon: '→',
  },
  {
    id: 'round_trip',
    label: 'Round Trip',
    tagline: 'Outstation & return',
    icon: '↔',
  },
  {
    id: 'local_rental',
    label: 'Local Rental',
    tagline: '4 / 8 / 12 hour trips',
    icon: '⏱',
  },
  {
    id: 'airport_transfer',
    label: 'Airport',
    tagline: 'Pickup or drop',
    icon: '✈',
  },
];

export const VEHICLE_OPTIONS = [
  { id: 'sedan', label: 'Sedan', seats: '4+1' },
  { id: 'suv', label: 'SUV', seats: '6+1' },
  { id: 'tempo_traveller', label: 'Tempo Traveller', seats: '12+1' },
  { id: 'bus', label: 'Bus', seats: '35+' },
];

export const RENTAL_HOURS = [4, 8, 12];
